export default firebase => {
  const db = firebase.firestore()
  
  return {
    authenticate(username, password) {
      return firebase.auth().signInWithEmailAndPassword(username, password)
    },
    async getUsers(partyId) {
      const doc = await db
        .collection("users")
        .doc(partyId)
        .get()

      return doc.data()
    },
    async getMessages(partyId) {
      const doc = await db
        .collection("messages")
        .doc(partyId)
        .get()

      return doc.data()
    },
    async getPendingMessages(partyId) {
      const doc = await db
        .collection("pendingMessages")
        .doc(partyId)
        .get()

      return doc.data()
    },
    onNewPendingMessages(partyId, onReceiveCallback) {
      db.collection("pendingMessages")
        .doc(partyId)
        .onSnapshot(convo => {
          if (convo && convo.data()) {
            onReceiveCallback(convo.data().pendingMessages)
          }
        })
    },
    onNewMessage(partyId, onReceiveCallback) {
      db.collection("messages")
        .doc(partyId)
        .onSnapshot(convo => {
          if (convo && convo.data()) {
            onReceiveCallback(convo.data().messages)
          }
        })
    },
    onNewUsers(partyId, onReceiveCallback) {
      db.collection("users")
        .doc(partyId)
        .onSnapshot(convo => {
          if (convo && convo.data()) {
            onReceiveCallback(convo.data().users)
          }
        })
    },
    setUsers(partyId, users) {
      return db
        .collection("users")
        .doc(partyId)
        .update({ users })
    },
    setMessages(partyId, messages) {
      return db
        .collection("messages")
        .doc(partyId)
        .update({ messages })
    },
    setPendingMessages(partyId, pendingMessages) {
      return db
        .collection("pendingMessages")
        .doc(partyId)
        .update({ pendingMessages })
    }
  }
}
